import AseanStories1 from "../../../assets/images/asean/asean_stories.webp";
import AseanStories2 from "../../../assets/images/asean/asean_stories_1.webp";
import AseanStories3 from "../../../assets/images/asean/asean_stories_2.webp";
import AseanStories4 from "../../../assets/images/asean/asean_stories_3.webp";
import AseanStories5 from "../../../assets/images/asean/asean_stories_4.webp";

export const ASEAN_STORIES = [
  {
    id: 1,
    src: AseanStories1,
    title: "page.asea.stories_1",
    href: "https://asean.nissannews.com/en/releases/nissan-thailand-achieves-green-industry-level-4-award-from-thailands-ministry-of-industry",
  },
  {
    id: 2,
    src: AseanStories2,
    title: "page.asea.stories_2",
    href: "https://asean.nissannews.com/en/releases/yes-nissan-plus-campaign-concludes-with-memorable-japan-experience-for-lucky-winners",
  },
  {
    id: 3,
    src: AseanStories3,
    title: "page.asea.stories_3",
    href: "https://asean.nissannews.com/en/releases/nissan-thailand-marks-a-milestone-with-the-successful-completion-of-the-line-integration",
  },
  {
    id: 4,
    src: AseanStories4,
    title: "page.asea.stories_4",
    href: "https://asean.nissannews.com/en/releases/nissan-and-siam-nissan-muang-nan-help-revive-nan-after-flood",
  },
  {
    id: 5,
    src: AseanStories5,
    title: "page.asea.stories_5",
    href: "https://asean.nissannews.com/en/releases/driven-by-vision-the-bold-design-behind-the-all-new-nissan-patrol",
  },
];
